import { Card, Chip, Grid, makeStyles, Typography } from '@material-ui/core'
import moment from 'moment';
import React from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router'
import { SEXO } from "../../utils/constants";
const useStyles = makeStyles((theme) => ({
    container:{
        paddingBottom:"0.5rem"
    },
    card:{
        padding:"1rem"
    },
    title:{
        marginBottom:"0.5rem"
    },
    chips:{
        margin:"0.20rem"
    }
}));

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function formatearSexo(idSexo) {
    
    switch (idSexo) {
      case SEXO.MASCULINO:
        return "MASCULINO";
      case SEXO.FEMENINO:
        return "FEMENINO";
      case SEXO.NO_INFORMADO:
        return "NO INFORMADO";
      case SEXO.NO_BINARIO:
        return "NO BINARIO";
      default:
        return null;
    }
  }

const ChipsFiltros = (props) => {
    const location=useLocation()
    const styles=useStyles()
    const query=useQuery();

    const seccionales = useSelector((state) => state.seccionales.items);
    const provincias = useSelector((state) => state.provincias.items);
    const localidades = useSelector((state) => state.localidades.items);
    const motivosBaja = useSelector((state) => state.motivosBaja.items);
    
    const {esSeccional, idSeccional} = props;

    if(location.search === "" && !esSeccional){
        return <></>
    }
    return (
        <Grid container className={styles.container}>
            <Grid item xs={12}>
                <Card className={styles.card}>
                    <Typography className={styles.title}>Filtros aplicados</Typography>
                    {
                        query.get("parentescos") &&
                        <Chip className={styles.chips} label={`Solo titulares`} />
                    }
                     {
                         query.get('motivoBaja') &&
                            <Chip className={styles.chips} label={`Motivo Baja: ${query.get("motivoBaja") === "0" ? "Todos" : motivosBaja.find(motivo=>motivo.id.toString() === query.get("motivoBaja"))?.descripcion}`} />
                    }
                    {
                        query.get("fecNacDesde") && query.get("fecNacHasta") &&
                        <Chip className={styles.chips} label={`Fecha de nacimiento desde ${moment(query.get("fecNacDesde")).format("DD/MM/YYYY")} hasta ${moment(query.get("fecNacHasta")).format("DD/MM/YYYY")}`} />
                    }
                    {
                        query.get("fecAltaDesde") && query.get("fecAltaHasta") &&
                        <Chip className={styles.chips} label={`Fecha de alta desde ${moment(query.get("fecAltaDesde")).format("DD/MM/YYYY")} hasta ${moment(query.get("fecAltaHasta")).format("DD/MM/YYYY")}`} />
                    }
                    {
                        query.get("fecBajaDesde") && query.get("fecBajaHasta") &&
                        <Chip className={styles.chips} label={`Fecha de baja desde ${moment(query.get("fecBajaDesde")).format("DD/MM/YYYY")} hasta ${moment(query.get("fecBajaHasta")).format("DD/MM/YYYY")}`} />
                    }
                    {

                        query.get('seccionales') && !esSeccional &&
                        query.get('seccionales').split(',').map(e=>{
                            return <Chip key={e} className={styles.chips} label={`Seccional: ${seccionales.find(sec=>sec.id_seccional.toString() === e).descripcion_seccional}`} />
                        })
                    }
                    {
                        esSeccional &&
                        <Chip key={idSeccional} className={styles.chips} label={`Seccional: ${seccionales.find(sec=>sec.id_seccional === idSeccional).descripcion_seccional}`} />
                    }
                    {
                        query.get('provincias') &&
                        query.get('provincias').split(',').map(e=>{
                            return <Chip key={e} className={styles.chips} label={`Provincia: ${provincias.find(prov=>prov.id_provincia.toString() === e).descripcion_provincia}`} />
                        })
                    }
                    {
                        query.get('localidades') &&
                        query.get('localidades').split(',').map(e=>{
                            return <Chip key={e} className={styles.chips} label={`Localidad: ${localidades.find(loc=>loc.id_localidad.toString() === e).descripcion_localidad}`} />
                        })
                    }
                    {
                        query.get('sexo') &&
                        <Chip className={styles.chips} label={`Sexo: ${formatearSexo(parseInt(query.get('sexo')))}`} />
                    }
                </Card>
            </Grid>
        </Grid>
    )
}

export default ChipsFiltros